var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "video-default-location-extend-box",
      class: { "video-default-location-extend-box-hidden": _vm.realHidden },
    },
    [
      _c(
        "div",
        {
          staticClass: "video-default-location-extend-box-bar",
          on: { click: _vm.setRealHidden },
        },
        [
          _c(
            "div",
            { staticClass: "video-default-location-extend-box-bar-text" },
            [_vm._v("位置测试")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "video-default-location-extend-box-bar-btn",
              class: _vm.btnClass,
              on: { animationend: _vm.onBarBtnAnimationEnd },
            },
            [_c("VIcon", { attrs: { icon: _vm.btnIcon, size: 15 } })],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "video-default-location-extend-box-content-wrap" },
        [
          _c(
            "transition",
            {
              attrs: {
                name: "video-default-location-extend-box-content-transition",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.realHidden,
                      expression: "!realHidden",
                    },
                  ],
                  staticClass: "video-default-location-extend-box-content",
                },
                [_vm._t("default")],
                2
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }